import { Tooltip2 } from '@blueprintjs/popover2';
import React from 'react';
import moment from 'moment';

import { getShiftSlotTheme } from '../../components/roster-utilities';
import { IRosterShift } from '../../types';
import { ROSTER_WEEKLY_CONFIG } from '../roster-weekly-config';
import { BookingTypeIcon } from 'common-components/tags';
import ShiftSlotStatusTag from 'common-components/tags/ShiftSlotStatusTag';
import { Text } from 'common-components/typography';
import { BookingType, ServiceType } from 'utilities/enum-utils';
import { Paper, UnstyledButton, Avatar } from '@good/ui/core';
import { useBookings } from 'views/bookings-v2/books-view-context/bookings-view-context';
import { ROSTER_TAB } from '../../components/roster-common-enums';

const { ITEM_CARD_HEIGHT } = ROSTER_WEEKLY_CONFIG;

interface AssignedShiftCardProps {
  shift: IRosterShift;
}

export const AssignedShiftCard = ({ shift }: AssignedShiftCardProps) => {
  const { shiftStartDateTime, shiftEndDateTime, shiftSlotStatus, serviceName } = shift;
  const mStartDate = moment(shiftStartDateTime);
  const mEndDate = moment(shiftEndDateTime);
  const startDateDisplay = mStartDate.format('h:mm a');
  const endDateDisplay = mEndDate.format('h:mm a');
  const { bgColor, borderColor } = getShiftSlotTheme(shiftSlotStatus);
  const onSelectRosterItem = useBookings((selector) => selector.onSelectRosterItem);
  const selectedRosterItem = useBookings((selector) => selector.selectedRosterItem);
  const isSelected = selectedRosterItem?.bookingId === shift.bookingId;
  const name = `${shift.customerFirstName?.[0]?.toUpperCase()} ${shift.customerLastName?.[0]?.toUpperCase()}`;

  return (
    <>
      <UnstyledButton
        onClick={() => onSelectRosterItem({ item: shift, type: 'workerShift', tab: ROSTER_TAB.WEEKLY })}
        w='100%'
        h='100%'
        display='flex'
        style={{
          boxShadow: isSelected ? '0 0 0 2px var(--mantine-color-lavender-6)' : '',
          borderRadius: 'calc(var(--mantine-radius-md) - 2px)',
        }}
      >
        <Paper
          withBorder
          w='100%'
          shadow={isSelected ? 'xl' : 'xs'}
          p={8}
          mih={ITEM_CARD_HEIGHT}
          bg={bgColor}
          className='anim-fade-in'
          style={{ overflow: 'hidden', borderColor }}
        >
          <div className={'flex-row justify-between align-center '}>
            <ShiftSlotStatusTag status={shiftSlotStatus} size={'small'} />
            {shift.serviceType === ServiceType.INDIVIDUAL && shift.bookingId && (
              <div className={'ml-small'}>
                <Tooltip2
                  content={<Text color={'white'}>{shift.customerFirstName + ' ' + shift.customerLastName}</Text>}
                  position={'bottom-right'}
                >
                  <div className={'flex-row align-center'}>
                    <Avatar size={20} name={name} color='initials' />
                  </div>
                </Tooltip2>
              </div>
            )}
          </div>

          <div className='whitespace-nowrap overflow-hidden text-overflow-ellipsis' style={{ width: '100%' }}>
            <Text size='regular' lineHeight={120}>
              <b>{startDateDisplay}</b> - {endDateDisplay}
            </Text>
            <br />
            <div className={'flex-row align-center'}>
              <div style={{ minWidth: '16px' }}>
                <BookingTypeIcon
                  type={
                    shift.bookingType === BookingType.ACTIVITY_RECORD ? BookingType.ACTIVITY_RECORD : shift.serviceType
                  }
                  className={'mr-x-small'}
                />
              </div>
              <Text size='regular' lineHeight={120}>
                {serviceName}
              </Text>
            </div>
          </div>
        </Paper>
      </UnstyledButton>
    </>
  );
};
